module.exports = __webpack_public_path__ + "img/Weapon_168.c8db641e.png";